const driver = {

  request (req, tokenStr) {
    const [accessToken, refreshToken] = tokenStr.split(';')
    let token = accessToken
    if (req.url.indexOf('refresh') > -1) {
      token = refreshToken
    }
    this.options.http._setHeaders.call(this, req, { Authorization: `Bearer ${token}` })
  },

  response (res) {
    if (res.data.access_token && res.data.refresh_token) {
      return `${res.data.access_token};${res.data.refresh_token}`
    }
  }
}

export default driver
